import React from 'react'
import "./topNavbar.css";
import { Box, Flex, Image, Text, AspectRatio, Link, Img } from "@chakra-ui/react";


 const TopNavbar = () => {

    return (
     <div>
        
     </div>
          
    )

}
export default TopNavbar

